"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfMinimumValidDateDto = instanceOfMinimumValidDateDto;
exports.MinimumValidDateDtoFromJSON = MinimumValidDateDtoFromJSON;
exports.MinimumValidDateDtoFromJSONTyped = MinimumValidDateDtoFromJSONTyped;
exports.MinimumValidDateDtoToJSON = MinimumValidDateDtoToJSON;
exports.MinimumValidDateDtoToJSONTyped = MinimumValidDateDtoToJSONTyped;
/**
 * Check if a given object implements the MinimumValidDateDto interface.
 */
function instanceOfMinimumValidDateDto(value) {
    if (!('minimumValidDate' in value) || value['minimumValidDate'] === undefined)
        return false;
    if (!('isDueToExposure' in value) || value['isDueToExposure'] === undefined)
        return false;
    return true;
}
function MinimumValidDateDtoFromJSON(json) {
    return MinimumValidDateDtoFromJSONTyped(json, false);
}
function MinimumValidDateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'minimumValidDate': (json['minimumValidDate'] == null ? null : new Date(json['minimumValidDate'])),
        'isDueToExposure': json['isDueToExposure'],
    };
}
function MinimumValidDateDtoToJSON(json) {
    return MinimumValidDateDtoToJSONTyped(json, false);
}
function MinimumValidDateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'minimumValidDate': (value['minimumValidDate'] == null ? null : value['minimumValidDate'].toISOString()),
        'isDueToExposure': value['isDueToExposure'],
    };
}
//# sourceMappingURL=MinimumValidDateDto.js.map